import { render, staticRenderFns } from "./template-update.vue?vue&type=template&id=6b1dc6c2&scoped=true&"
import script from "./template-update.vue?vue&type=script&lang=js&"
export * from "./template-update.vue?vue&type=script&lang=js&"
import style0 from "./template-update.vue?vue&type=style&index=0&lang=less&"
import style1 from "./template-update.vue?vue&type=style&index=1&id=6b1dc6c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1dc6c2",
  null
  
)

export default component.exports